import { render, staticRenderFns } from "./TableMundialSliderInformador.vue?vue&type=template&id=244ac895&"
import script from "./TableMundialSliderInformador.vue?vue&type=script&lang=js&"
export * from "./TableMundialSliderInformador.vue?vue&type=script&lang=js&"
import style0 from "./TableMundialSliderInformador.vue?vue&type=style&index=0&id=244ac895&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports